const splitWithLimit = (str, reg, limit) => {
  const split = str.split(reg);
  const result = split.splice(0, limit);
  result.push(split.join(reg));
  return result;
};

export default splitWithLimit;
